import { RevistaEffects } from './store/revista/revista.effects';
import { AplicacionService } from './services/aplicacion.service';
import { AccesoEffects } from './store/acceso/acceso.effects';
import { RecursosHumanosEffects } from './store/recursos-humanos/recursos-humanos.effects';
import { PizarraEffects } from './store/pizarra/pizarra.effects';
import { ContenidoService } from './services/contenido.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DestacadoComponent } from './destacado/destacado.component';
import { ContenidoComponent } from './contenido/contenido.component';
import { InfoComponent } from './info/info.component';
import { MenuComedorComponent } from './info/menu-comedor/menu-comedor.component';
import { PizarraComponent } from './info/pizarra/pizarra.component';
import { SelfServiceComponent } from './info/self-service/self-service.component';
import { DetalleComponent } from './detalle/detalle.component';
import { EventoComponent } from './info/evento/evento.component';
import { StoreModule } from '@ngrx/store';
import { contenidoReducer } from './store/contenido/contenido.reducers';
import { buscadorPersonasReducer } from './store/buscador-personas/buscador-personas.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ContenidoEffects } from './store/contenido/contenido.effects';
import { DetalleEffects } from './store/detalle/detalle.effects';
import { detalleReducer } from './store/detalle/detalle.reducers';
import { DetalleResolver } from './detalle/detalle.resolver';
import { destacadoReducer } from './store/destacado/destacado.reducers';
import { DestacadoEffects } from './store/destacado/destacado.effects';
import { HttpClientModule } from '@angular/common/http';
import { ComunidadComponent } from './comunidad/comunidad.component';
import { HomeComponent } from './home.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { InteresComponent } from './interes/interes.component';
import { menuComedorReducer } from './store/menu-comedor/menu-comedor.reducers';
import { MenuComedorEffects } from './store/menu-comedor/menu-comedor.effects';
import { MenuComedorService } from './services/menu-comedor.service';
import { PizarraService } from './services/pizarra.service';
import { pizarraReducer } from './store/pizarra/pizarra.reducers';
import { MesaAyudaComponent } from './mesa-ayuda/mesa-ayuda.component';
import { recursosHumanosReducer } from './store/recursos-humanos/recursos-humanos.reducers';
import { RecursosHumanosService } from './services/recursos-humanos.service';
import { accesoReducer } from './store/acceso/acceso.reducers';
import { AplicacionComponent } from './aplicacion/aplicacion.component';
import { RevistaComponent } from './revista/revista.component';
import { revistaReducer } from './store/revista/revista.reducers';
import { ViolenciaComponent } from './reporte/violencia/violencia.component';
import { emailReducer } from './store/email/email.reducers';
import { EmailEffects } from './store/email/email.effects';
import { EmailService } from './services/email.service';
import { aplicacionReducer } from './store/aplicacion/aplicacion.reducer';
import { AplicacionEffects } from './store/aplicacion/aplicacion.effects';
import { beneficioReducer } from './store/beneficio/beneficio.reducer';
import { BeneficioEffects } from './store/beneficio/beneficio.effects';
import { BeneficioComponent } from './beneficio/beneficio.component';
import { AboutComponent } from './about/about.component';
import { SalutacionComponent } from './salutacion/salutacion.component';
import { salutacionReducer } from './store/salutacion/salutacion.reducers';
import { SalutacionEffects } from './store/salutacion/salutacion.effects';
import { EmailComponent } from './email/email.component';
import { RecursosComponent } from './recursos/recursos.component';
import { FaltantesComponent } from './reporte/faltantes/faltantes.component';
import { CumplesComponent } from './cumples/cumples.component';
import { cumplesReducer } from './store/cumples/cumples.reducer';
import { CumplesEffects } from './store/cumples/cumples.effects';
import { CumplesService } from './services/cumples.service';
import { ReactiveFormsModule } from '@angular/forms';
import { EmergenciaComponent } from './reporte/emergencia/emergencia.component';
import { BuscadorPersonasComponent } from './buscador-personas/buscador-personas.component';
import { BuscadorPersonasEffects } from './store/buscador-personas/buscador-personas.effects';
import { BuscadorPersonasService } from './services/buscador-personas.service';
import { HumandBannerComponent } from './humand-banner/humand-banner.component';
import { informacionPersonalReducer } from 'src/app/mi-perfil/store/informacion-persional/informacion-personal.reducer';

@NgModule({
	declarations: [
		HomeComponent,
		DestacadoComponent,
		ContenidoComponent,
		DetalleComponent,
		InfoComponent,
		MenuComedorComponent,
		PizarraComponent,
		SelfServiceComponent,
		EventoComponent,
		ComunidadComponent,
		InteresComponent,
		MesaAyudaComponent,
		AplicacionComponent,
		RevistaComponent,
		ViolenciaComponent,
		BeneficioComponent,
		AboutComponent,
		SalutacionComponent,
		EmailComponent,
		RecursosComponent,
		FaltantesComponent,
		CumplesComponent,
		EmergenciaComponent,
		BuscadorPersonasComponent,
		HumandBannerComponent,
	],
	imports: [
		CommonModule,
		RouterModule,
		ReactiveFormsModule,
		NgbModule,
		HttpClientModule,
		SharedModule,
		StoreModule.forFeature( 'aplicacion', aplicacionReducer ),
		StoreModule.forFeature( 'acceso', accesoReducer ),
		StoreModule.forFeature( 'beneficio', beneficioReducer ),
		StoreModule.forFeature( 'contenido', contenidoReducer ),
		StoreModule.forFeature( 'buscador-personas', buscadorPersonasReducer ),
		StoreModule.forFeature( 'informacion-personal', informacionPersonalReducer ),
		StoreModule.forFeature( 'detalle', detalleReducer ),
		StoreModule.forFeature( 'destacado', destacadoReducer ),
		StoreModule.forFeature( 'email', emailReducer ),
		StoreModule.forFeature( 'menu-comedor', menuComedorReducer ),
		StoreModule.forFeature( 'pizarra', pizarraReducer ),
		StoreModule.forFeature( 'recursos-humanos', recursosHumanosReducer ),
		StoreModule.forFeature( 'revista', revistaReducer ),
		StoreModule.forFeature( 'salutacion', salutacionReducer ),
		StoreModule.forFeature( 'cumples', cumplesReducer ),
		EffectsModule.forFeature( [
			AplicacionEffects,
			AccesoEffects,
			BeneficioEffects,
			BuscadorPersonasEffects,
			ContenidoEffects,
			DetalleEffects,
			DestacadoEffects,
			EmailEffects,
			MenuComedorEffects,
			PizarraEffects,
			RecursosHumanosEffects,
			RevistaEffects,
			SalutacionEffects,
			CumplesEffects
		] )
	],
	providers: [
		BuscadorPersonasService,
		ContenidoService,
		MenuComedorService,
		PizarraService,
		RecursosHumanosService,
		AplicacionService,
		EmailService,
		CumplesService,
		DetalleResolver
	],
	exports: [
		HomeComponent
	]
})
export class HomeModule {
}
